import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllApprovalList } from "../../../../services/fetchListingData";
import {

  APPROVE,
  REJECTED,
  RNCREJECTED,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import ResizeListner from "../../../../utility/ResizeListner";
import {
  RejectedListHeadersAdmin,
  RejectedListHeadersRnc,
} from "../../../../utility/TableHeaders";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import ViewMoreApproval from "../../../components/ui_comps/approval_comps/ViewMoreApproval";
import { useSnackbar } from "notistack";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";


function RejectedApproval({ onChange, status }) {
  const { height } = ResizeListner();


  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const [clientData, setClientData] = useState(false);
  const [onClickViewMore, setOnClickViewMore] = useState("");
  const approvalData = useSelector((state) => state.listingSlice.approvalList);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const onClickApproveReject = (clientId, status) => {
    setLoading(true);
    ApiRequestPost.adminApproveRejectAction({
      clientId,
      status,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          setOnClickViewMore(false);
          dispatch(
            fetchAllApprovalList({
              dateRange: "",
              page: 0,
              size: 10,
              // activeStatus: "",
              onBoardedStatus: status,
              userRefId: "",
            })
          );
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };
  useEffect(() => {
    dispatch(
      fetchAllApprovalList({
        dateRange: "",
        page: 0,
        size: 10,
        activeStatus: "",
        onBoardedStatus: status,
        userRefId: "",
        deactivatedList: true,
      })
    );
  }, [status]);
  return (
    <div>
      <div style={{ padding: "0px 20px", overflow: "hidden" }}>
        <CustomTable
          styles={{
            maxHeight: height * 0.7,
            minHeight: height * 0.7,
          }}
          currentPage={approvalData?.currentPageNo - 1}
          data={approvalData?.clients}
          headers={
            status === REJECTED
              ? RejectedListHeadersAdmin
              : status == RNCREJECTED
              ? RejectedListHeadersRnc
              : null
          }
          totalElements={approvalData?.totalRecords}
          totalPages={approvalData?.totalPages}
          handlePaginate={(page) => {
            setCurrentPage(page);
            dispatch(
              fetchAllApprovalList({
                dateRange: "",
                page: page + 1,
                size: 10,
                activeStatus: "",
                onBoardedStatus: status,
                userRefId: "",
                deactivatedList: true,
              })
            );
          }}
          onViewMore={(row) => {
            setClientData(row);
            onChange(true, row);
          }}
        />
      </div>

      {onClickViewMore && (
        <CustomModal
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
          open={onClickViewMore}
          isBackRequired={false}
          isHeaderRequired={false}
          onClose={() => {
            setOnClickViewMore(false);
          }}
        >
          <ViewMoreApproval
            onClose={() => {
              setOnClickViewMore(false);
            }}
            data={clientData}
            isButtonsRequired={false}
            onSuccess={() => {}}
            isActiveButtonRequired={true}
            onClickApproveReject={(userId) => {
              onClickApproveReject(userId, APPROVE);
            }}
            loading1={loading}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default RejectedApproval;
